﻿import React, { ReactNode } from 'react';

import { ButtonGroup, Dropdown } from 'react-bootstrap';
import { Variant } from 'react-bootstrap/esm/types';
import { useIntl } from 'react-intl';

import 'components/GMetrixButtonDropdown/gmetrix-button-dropdown.scss';

export interface DropdownMenuItem {
    action: () => any;
    disabled?: boolean;
    hidden?: boolean;
    iconClass?: string;
    text: string | ReactNode;
}

interface GMetrixButtonDropdownProps {
    ariaLabel?: string;
    autoClose?: boolean | 'inside' | 'outside';
    buttonText?: string;
    className?: string;
    connectedButton?: ReactNode;
    dataItems: DropdownMenuItem[];
    disabled?: boolean;
    drop?: 'up' | 'up-centered' | 'down' | 'down-centered' | 'start' | 'end';
    iconClass?: string;
    variant?: Variant;
}

export function GMetrixButtonDropdown({
    ariaLabel,
    autoClose,
    buttonText,
    className,
    connectedButton,
    dataItems,
    disabled = false,
    drop,
    iconClass,
    variant,
    ...otherProps
}: GMetrixButtonDropdownProps) {

    const { formatMessage } = useIntl();

    // Icon-only toggles (no visible buttonText) need an explicit accessible name.
    const toggleAriaLabel = buttonText ? undefined : (ariaLabel ?? formatMessage({ id: 'more_options.8f8dab90', defaultMessage: 'More options' }));

    return (
        <Dropdown
            as={ButtonGroup}
            autoClose={autoClose}
            drop={drop}
            style={{ overflow: 'visible !important' }}
            {...otherProps}
        >
            {connectedButton}
            <Dropdown.Toggle
                aria-label={toggleAriaLabel}
                className={`${className && className.length > 0 ? className : ''} text-nowrap dropdown-button-toggle`}
                disabled={disabled}
                variant={variant}
            >
                <>
                    {iconClass && iconClass.length > 0 && <i aria-hidden="true" className={`${iconClass} align-baseline`} ></i>}
                    {buttonText === undefined ? <></> : (
                        <span className="mx-2">
                            {' ' + buttonText}
                        </span>
                    )}

                </>
            </Dropdown.Toggle>
            <Dropdown.Menu popperConfig={{ strategy: 'fixed' }} style={{ position: 'fixed' }}>
                {dataItems?.map((item, index) => {

                    if (item.hidden) {

                        return;

                    }
                    return (
                        <Dropdown.Item disabled={item.disabled} key={`dropdown-${index}`} onClick={item.action}>
                            {/* I like the icons but for now it is a no sadly */}
                            {/* {item.iconClass &&
                    <i className={`me-2 fa-light ${item.iconClass}`}>
                    </i>
                    } */}
                            {item.text}
                        </Dropdown.Item>
                    );

                })}
            </Dropdown.Menu>
        </Dropdown>
    );

}
